import { useCallback, useState } from 'react';

const useTablePages = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const onPageChange = (newSeriesData: string) => {
    setPage(Number(newSeriesData));
  };

  const onRowsPerPageChange = (newSeriesData: PaginationLimit) => {
    setRowsPerPage(newSeriesData);
    setPage(1);
  };

  const resetPage = useCallback(() => {
    setPage(1);
  }, []);

  const onPrevPageClick = () => {
    setPage((prevValue) => prevValue - 1);
  };

  const onNextPageClick = () => {
    setPage((prevValue) => prevValue + 1);
  };

  return {
    page,
    rowsPerPage,
    resetPage,
    onPageChange,
    onRowsPerPageChange,
    onPrevPageClick,
    onNextPageClick,
    setPage,
  };
};

export default useTablePages;
